export function createArticleLink(permalink: string) {
  return `/public/article/news/${permalink}`;
}

export function createDietQaArticleLink(permalink: string) {
  return `/public/article/dietqa/${permalink}`;
}
